// WIP
import { Directive, Input } from '@angular/core';
import { UntypedFormControl, Validator, NG_VALIDATORS } from '@angular/forms';


@Directive({
  selector: '[appDuplicatedVisualIdValidator][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: DuplicatedVisualIdValidatorDirective,
      multi: true
    }
  ]
})
export class DuplicatedVisualIdValidatorDirective implements Validator {
  @Input() visualIdList: Array<any>;
  @Input() visualIdIndex: number;

  constructor() { }

  validate(control: UntypedFormControl): { [key: string]: any } {
    let isDuplicated = null;

    if (!!control.value) {
      for (let i = 0; i < this.visualIdList.length; i++) {
        if (
          this.visualIdIndex !== i &&
          this.visualIdList[i].entitlementId === control.value
        ) {
          isDuplicated = { 'duplicatedVid': true };
          break;
        }
      }
    }

    return isDuplicated;
  }

}
